/**
 * @license Copyright (c) 2003-2022, RAONWIZ DevTeam. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RaonkUploadComponent } from './raonkupload.component';

@NgModule( {
	imports: [ FormsModule, CommonModule ],
	declarations: [ RaonkUploadComponent ],
	exports: [ RaonkUploadComponent ]
} )
export class RaonkUploadModule {
}
export * from './raonkupload';
export { RaonkUploadComponent } from './raonkupload.component';
